// ── Service de Tags (núcleo/aplicação) ────────────────────────────
// Validações/normalização em torno de tags e lead_tags. I/O via porta.

import type { ITagRepository, Tag, LeadTag } from '../ports/ITagRepository';

export class TagService {
  constructor(private readonly repo: ITagRepository) {}

  listTags = async (workspaceId: string | null | undefined): Promise<Tag[]> => {
    if (!workspaceId) return [];
    return this.repo.listTags(workspaceId);
  };

  createTag = async (workspaceId: string, name: string, color = '#2563C8'): Promise<Tag> => {
    if (!workspaceId) throw new Error('workspace_id e obrigatorio.');
    if (!name?.trim()) throw new Error('Nome da tag e obrigatorio.');
    return this.repo.insertTag({ workspaceId, name: name.trim(), color: color || '#2563C8' });
  };

  updateTag = async (
    tagId: string,
    { name, color }: { name?: string | null; color?: string | null } = {},
  ): Promise<Tag | null> => {
    if (!tagId) throw new Error('tag_id e obrigatorio.');
    const updates: { name?: string; color?: string } = {};
    if (name != null && String(name).trim()) updates.name = String(name).trim();
    if (color) updates.color = color;
    if (Object.keys(updates).length === 0) return null;
    return this.repo.updateTag(tagId, updates);
  };

  addTagToLead = async (leadId: string, tagId: string): Promise<LeadTag | null> => {
    if (!leadId || !tagId) throw new Error('lead_id e tag_id sao obrigatorios.');
    return this.repo.insertLeadTag(leadId, tagId);
  };

  removeTagFromLead = async (leadId: string, tagId: string): Promise<void> => {
    if (!leadId || !tagId) throw new Error('lead_id e tag_id sao obrigatorios.');
    return this.repo.deleteLeadTag(leadId, tagId);
  };

  listLeadTags = async (leadId: string | null | undefined): Promise<Tag[]> => {
    if (!leadId) return [];
    return this.repo.listTagsByLead(leadId);
  };
}
